/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IAccountInvoiceTileDescription {
    description: string;
}

export const AccountInvoiceTileDescription: React.FC<IAccountInvoiceTileDescription> = ({ description }) => (
    <p className='ms-account-invoice-tile__description'>{description}</p>
);
